// SidebarCard.tsx
import React from "react";
import Logo from "assets/img/logo_bc.png";

/**
 * Escudo del club al pie del sidebar. Es una firma, no un elemento de
 * navegación: opacidad baja en reposo y se revela al pasar el mouse.
 */
const FreeCard = () => (
  <img
    src={Logo}
    className="h-24 w-24 opacity-40 transition-opacity duration-300 ease-premium hover:opacity-70 dark:opacity-50 dark:hover:opacity-80"
    alt="Escudo del club"
  />
);

export default FreeCard;
